import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./PackageList.css";
import OdooService from '../../../services/odooService';
import LoadingOverlay from "../../../components/LoadingOverlay/LoadingOverlay";
import { FaRegTrashAlt } from "react-icons/fa";

export default function PackageList() {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { type, location_id } = state || {};

    const [packages, setPackages] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);
    const [title, setTitle] = useState('');

    useEffect(() => {
        if (location_id && type) {
            loadData(location_id, type, page);
        }
    }, [type, location_id, page]);

    const loadData = async (location_id, type, page) => {
        setLoading(true);
        try {
            const result = await OdooService.showPackages(location_id, type, page);
            if (result.success) {
                setTitle(result.title)
                setPackages(result.packages);
                setTotalPages(result.pages);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleClean = async (package_name) => {
        setLoading(true);
        try {
            const result = await OdooService.actionCleanInventory(location_id, package_name);
            if (result.success) {
                loadData(location_id, type, page);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="package-list-page">
            {loading && <LoadingOverlay />}

            <header className="package-list-header">
                <h1 className="package-list-title">{title}</h1>
            </header>

            <div className="package-list-container">

                <div className="package-list-table">

                    <div className="package-list-row header">
                        <div className="package-col">Paquetes</div>
                    </div>

                    {packages.map(pkg => (
                        <div key={pkg.package_name} className="package-list-row">
                            <div className="package-col">
                                <strong>{pkg.package_name}</strong>
                                {type === 'scanned' && (
                                    <button
                                        className="btn-clean"
                                        onClick={() => handleClean(pkg.package_name)}
                                    >
                                        <FaRegTrashAlt />
                                    </button>
                                )}
                                <br />
                                <span>{pkg.package_weight} {pkg.uom_name_package}</span>

                                <p>
                                    {pkg.products.map((prod) => (
                                        <li key={prod}>{prod}</li>
                                    ))}
                                </p>
                            </div>
                        </div>
                    ))}

                    {packages.length === 0 && (
                        <p className="empty-msg">No hay paquetes disponibles</p>
                    )}
                </div>

                <div className="pagination-controls">
                    <button
                        className="btn-pagination"
                        disabled={page <= 1}
                        onClick={() => setPage(prev => prev - 1)}
                    >
                        Anterior
                    </button>

                    <span className="page-info">
                        Página {page} de {totalPages}
                    </span>

                    <button
                        className="btn-pagination"
                        disabled={page >= totalPages}
                        onClick={() => setPage(prev => prev + 1)}
                    >
                        Siguiente
                    </button>
                </div>

                <button
                    className="btn-back"
                    onClick={() => navigate(-1)}
                >
                    Volver
                </button>

            </div>
        </div>
    );
}
